<template lang="pug">
  div(v-if="vertical")
    el-radio-group(v-model="radio", @change="changeRadio")
      el-row.radio
        el-radio(label="no") {{ noWord }}
      el-row.radio
        el-radio(label="yes") {{ yesWord }}
  div.text.row(v-else)
    el-col(:span="9")
      slot
    el-col(:span="7")
      el-radio-group(v-model="radio", @change="changeRadio")
        el-radio(label="no") ไม่ทำ
        el-radio(label="yes") ทำ
    el-col(:span="8")
      el-input(v-if="showInput === true", v-model="input", @input="$emit('update:inputValue', $event)",
        :disabled="radioValue === false", :placeholder="placeHolder")
</template>

<style lang="scss" scoped>
.row {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.text {
  color: #606266;
  font-size: 18px;
  font-weight: 400;
  line-height: 2.2;
}
.radio {
  margin-top: 12px;
  margin-left: 0px;
  font-size: 16px;
}

</style>

<script>
export default {
  name: 'radioYesNoInput',
  props: ['radioValue', 'inputValue', 'showInput', 'placeHolder', 'vertical', 'yesWord', 'noWord'],
  data () {
    return {
      input: '',
      radio: '',
    }
  },
  watch: {
    radioValue (val, oldVal) {
      this.radio = val ? 'yes' : 'no'
    },
    inputValue (val, oldVal) {
      this.input = val
    },
  },
  methods: {
    // changeInput (value) {
    //   this.$emit('update:inputValue', this.input)
    // },
    changeRadio (value) {
      if (value === 'no') {
        this.$emit('update:inputValue', '')
      }
      this.$emit('update:radioValue', value === 'yes')
    },
  },
}
</script>
